import {
  SERVICE_QUEUE_DIALOG_MESSAGES,
  ServiceQueueDialogMessages,
} from "./service-queue-dialog.messages";
import {
  SERVICE_QUEUE_FORM_MESSAGES,
  ServiceQueueFormMessages,
} from "./service-queue-form.messages";
import {
  SERVICE_QUEUE_REQUEST_MESSAGES,
  ServiceQueueRequestMessages,
} from "./service-queue-request.messages";
import {
  SERVICE_QUEUE_TABLE_MESSAGES,
  ServiceQueueTableMessages,
} from "./service-queue-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type ServiceQueueMessages = ActionButtonMessages &
  SidebarMessages &
  PopoverMessages &
  ServiceQueueFormMessages &
  ServiceQueueRequestMessages &
  ServiceQueueTableMessages &
  ServiceQueueDialogMessages & {
    pageTitle: string;
    breadCrumbTitle: string;
    createPageTitle: string;
    updatePageTitle: string;
    viewPageTitle: string;
    serviceQueueTableTitle: string;
    addServiceQueueButton: string;
  };

export const SERVICE_QUEUE_MESSAGES: ServiceQueueMessages = {
  pageTitle: "Filas de Atendimento",
  createPageTitle: "Criar Fila de Atendimento",
  updatePageTitle: "Editar Fila de Atendimento",
  viewPageTitle: "Visualizar Fila de Atendimento",
  serviceQueueTableTitle: "Listagem de Filas de Atendimento",
  breadCrumbTitle: "Filas de Atendimento",
  addServiceQueueButton: "Nova Fila +",

  ...SERVICE_QUEUE_DIALOG_MESSAGES,
  ...SERVICE_QUEUE_TABLE_MESSAGES,
  ...SERVICE_QUEUE_REQUEST_MESSAGES,
  ...SERVICE_QUEUE_FORM_MESSAGES,

  ...POPOVER_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};
